import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import { ParamListBase } from "@react-navigation/native"
import TransactionsByDate from "../../transactions/transactions-by-date"
import CompanyProfile from "../../company-profile"
import ScreenHeader from "../../utility/ScreenHeader"
import CompanySearchResults from "../../explore/company-search-results"

const Stack = createStackNavigator<ParamListBase>()

const TransactionsStack = () => {
  return (
    <Stack.Navigator screenOptions={{ gestureEnabled: false }} id={undefined}>
      <Stack.Screen
        name="TransactionsHome"
        component={TransactionsByDate}
        options={{
          title: 'Transactions',
          header: function TransactionsHeader() {
            return (
              <ScreenHeader
                title="Transactions"
                goBackEnabled={true}
                functionality="search-transaction"
              />
            )
          },
        }}
      />
      <Stack.Screen
        name="CompanySearchResults"
        component={CompanySearchResults}
        options={{
          title: "Search Results",
          header: function CompanySearchResultsHeader() {
            return (
              <ScreenHeader
                title="Search Results"
                goBackEnabled
                functionality="search-company"
              />
            )
          }
        }}
      />
      <Stack.Screen
        name="Company"
        component={CompanyProfile}
        options={({ route }: any) => ({
          header: function CompanyProfileHeader() {
            return (
              <ScreenHeader
                title={route.params?.company?.name || route.params?.name}
                goBackEnabled
                functionality="search-company"
              />
            )
          },
          title: route.params?.company?.name || route.params?.name || "Company Profile",
        })}
      />
    </Stack.Navigator>
  )
}

export default TransactionsStack


